import { createContext } from "react"
import { TopicQuestionFeedback } from "shared/types/submissionTypes"

export type TopicFeedbackContextType = {
    feedback: TopicQuestionFeedback[]
}

export const TopicFeedbackContext = createContext<TopicFeedbackContextType>({
    feedback: []
})
